const ProgressBar = ({ step, nextStep, prevStep }) => {
    return (
        <div className="flex justify-center space-x-2 mt-2 pb-6 pt-6 md:pt-2 md:pb-2 sl:pt-2 ll:pt-2 sl:pb-2 ll:pb-2">
            <div
                className={`h-2 w-20 rounded-full cursor-pointer ${step >= 1 ? "bg-blue-600" : "bg-gray-300"
                    }`}
                onClick={prevStep}
            ></div>
            <div
                className={`h-2 w-20 rounded-full cursor-pointer ${step >= 2 ? "bg-blue-600" : "bg-gray-300"
                    }`}
                onClick={nextStep}
            ></div>
        </div>
    );
};

export default ProgressBar;
